import { render, staticRenderFns } from "./TitleBlock.vue?vue&type=template&id=201195e1&scoped=true&lang=pug&"
import script from "./TitleBlock.vue?vue&type=script&lang=ts&"
export * from "./TitleBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TitleBlock.vue?vue&type=style&index=0&id=201195e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201195e1",
  null
  
)

export default component.exports